<script>
  import { createEventDispatcher, getContext } from 'svelte';
  import { Link } from 'svelte-navigator';
  import { ListGroup } from '@sveltestrap/sveltestrap';

  import { NotificationsItem } from '@client/components/notifications-item';

  /**
   * @typedef {Object} Notification
   * @property {'adclick' | 'attachmentdownload' | 'attachmentview' | 'beaconview' | 'linkclick' | 'msg' | 'videoactivity' | 'websitevisit'} objecttype - The type of activity.
   * @property {string} recipient - The email recipient of the notification.
   * @property {string} msgsubject - The email subject of the notification.
   * @property {boolean} unread - Indicates whether the notification is unread.
   * @property {Date} utcts - the date and time of the notification.
   */

  /**
   * The array of notifications, if any.
   * @type {Array<{Notification}>}
   * @default []
   */
  export let notifications = [];

  // TODO link direct to activity, needs page support first

  const getSubject = (activity) => {
    switch (activity.objecttype) {
      case 'adclick':
        return activity.note?.name;
      case 'attachmentdownload':
      case 'attachmentview':
        return activity.note?.filename;
      case 'linkclick':
        return activity.note?.linkname;
      case 'beaconview':
      case 'msg':
        return activity.msgsubject;
      default:
        return activity.msgsubject;
    }
  };

  const dispatcher = createEventDispatcher();
  const context = getContext('dropdownContext');

  let viewed = false;

  $: {
    if ($context.isOpen) {
      // When the dropdown is opened, viewed
      viewed = true;
    } else if (viewed) {
      dispatcher('viewed');
    }
  }
</script>

<div class="notifications-menu rounded-md">
  <ListGroup flush>
    {#each notifications as activity}
      <Link {...$$restProps} class="list-group-item list-group-item-action" to="/insights/activity#activity-feed">
        <NotificationsItem
          type={activity.objecttype}
          recipient={activity.recipient}
          subject={getSubject(activity)}
          unread={activity.unread}
          date={activity.utcts}
        />
      </Link>
    {/each}
  </ListGroup>
</div>

<style lang="scss" src="./notifications-menu.scss"></style>
